import React, { FC } from 'react'

import { MasterCampaignPlanCustomSection } from 'api/interfaces/MasterCampaignPlan'
import { MasterCampaignPlanCampaignBuilder } from 'api/interfaces/MasterCampaignStub'

import { getChannelUtilizationContent } from '../../utils/planContentUtils'
import CustomizableSection from './CustomizableSection'

export interface ChannelUtilizationProps {
  campaigns: MasterCampaignPlanCampaignBuilder[]
  section: MasterCampaignPlanCustomSection | null | undefined
  onEdit: () => void
  onDelete: () => void
  showActions?: boolean
}

const ChannelUtilization: FC<ChannelUtilizationProps> = ({ campaigns, section, onEdit, onDelete, showActions = true }) => {
  const channelContent = getChannelUtilizationContent(campaigns)

  if (!channelContent) {
    return null
  }

  return <CustomizableSection section={section} defaultTitle='Channel Utilization' defaultContent={channelContent} defaultShowTitle={true} separator='spacer' onEdit={onEdit} onDelete={onDelete} showActions={showActions} />
}

export default ChannelUtilization
